export const transferThumbnailURL = (imageId, merchanId, fileExtension) => `https://shoplineimg.com/${merchanId}/${imageId}/400x.webp?source_format=${fileExtension}`;
export const getImageFileExtension = (url) => url.split('.').pop().split('?').shift();
export function getName({ obj, i18n, isEngFirst = false }) {
  if (isEngFirst) {
    return obj.en
      ? obj.en
      : obj['zh-hant']
  } else {
    if (obj?.[i18n]?.trim()) {
      return obj[i18n]
    } else {
      return obj?.en?.trim()
        ? obj.en
        : obj['zh-hant']
    }
  }
  return obj
}
